// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/design-system/components/actions/IconButton.jsx

import React from "react";

function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

export default function IconButton({
  label,
  children,
  variant = "ghost",
  size = "medium",
  className = "",
  type = "button",
  ...buttonProps
}) {
  return (
    <button
      {...buttonProps}
      type={type}
      aria-label={label}
      title={buttonProps.title || label}
      className={joinClassNames(
        "oasys-icon-button",
        `oasys-icon-button--${variant}`,
        `oasys-icon-button--${size}`,
        className
      )}
    >
      {children}
    </button>
  );
}
